var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.342,
    height: 25.75,
    viewBox: "0 0 26.342 25.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1 {\n        stroke-linejoin: round;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #7d7d7d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11282",
    "data-name": "Group 11282",
    transform: "translate(-823.25 -3011.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    className: "cls-1",
    d: "M20.147,19.354a11.341,11.341,0,0,0,2.96-7.675,11.429,11.429,0,1,0-12.249,11.4",
    transform: "translate(823.75 3011.75)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10158",
    "data-name": "Group 10158",
    transform: "translate(833.571 3016.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7140",
    "data-name": "Path 7140",
    className: "cls-2",
    d: "M1.857,0A1.857,1.857,0,1,1,0,1.857",
    transform: "translate(3.714 3.714) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7142",
    "data-name": "Path 7142",
    className: "cls-2",
    d: "M1.857,0A1.857,1.857,0,1,1,0,1.857",
    transform: "translate(0 10.286)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10159",
    "data-name": "Group 10159",
    transform: "translate(828.143 3021.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7141",
    "data-name": "Path 7141",
    className: "cls-2",
    d: "M1.857,0A1.857,1.857,0,1,1,0,1.857",
    transform: "translate(11.143 3.714) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7143",
    "data-name": "Path 7143",
    className: "cls-2",
    d: "M1.857,0A1.857,1.857,0,1,1,0,1.857",
    transform: "translate(3.714 0) rotate(90)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1825",
    "data-name": "Ellipse 1825",
    className: "cls-3",
    cx: 2.143,
    cy: 2.143,
    r: 2.143,
    transform: "translate(836.143 3032.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7144",
    "data-name": "Path 7144",
    className: "cls-1",
    d: "M63.285,80.25h6.832",
    transform: "translate(778.725 2954.607)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPlayer);
export default __webpack_public_path__ + "static/media/mediaPlayer.e734da6ada1706e5c0b18750727b738d.svg";
export { ForwardRef as ReactComponent };